<div class="Encabezado-bienvenida">
    <img src="../../../../assets/images/Bienvenidafinal.png">
</div>
<div class="Encabezado-texto-bienvenida bc-align-text-center bc-text-center">
    <h2>Para comenzar haz clic en el ícono de menú</h2>
</div>

